import type { NewsItem } from '@structural-climbing/ui'
import { isNewsNew, type NewsFeed } from './useNews'
import { isUpcoming } from './sortNews'

export interface SplitFeed {
  gymEvents: NewsItem[]
  communityEvents: NewsItem[]
  gymNews: NewsItem[]
  communityNews: NewsItem[]
  appUpdates: NewsItem[]
}

// One feed, two pages: events go to the Events page whatever their origin, and
// everything else stays on News. App updates are always global and never events.
export function splitFeed(feed: NewsFeed): SplitFeed {
  const gymEvents = feed.gym.filter((i) => i.is_event)
  const gymNews = feed.gym.filter((i) => !i.is_event)
  const communityEvents = feed.global.filter((i) => i.is_event && !i.is_app_update)
  const communityNews = feed.global.filter((i) => !i.is_event && !i.is_app_update)
  const appUpdates = feed.global.filter((i) => i.is_app_update)
  return { gymEvents, communityEvents, gymNews, communityNews, appUpdates }
}

/**
 * Events that have not happened yet.
 *
 * The only thing that clears an event's bullet, at every level of the nav and on
 * the page's own tabs. Deliberately blind to both `joined` and the seen record:
 * an event you have opened the page for, or even signed up to, is still the next
 * thing happening at your gym, and the bullet is what stops it being forgotten.
 * A count only because the desktop sidebar shows one; every phone surface reads
 * it as "more than zero".
 */
export function liveEventCount(events: NewsItem[], now: number = Date.now()): number {
  return events.filter((i) => isUpcoming(i, now)).length
}

// News, unlike an event, is finished with once it has been read — so this one
// does subtract the seen record. The 7-day floor stays: without it a member
// joining today would be greeted by a bullet counting the entire backlog.
export function unseenNewsCount(items: NewsItem[], seen: ReadonlySet<string>): number {
  return items.filter((i) => isNewsNew(i.news_date) && !seen.has(i.id)).length
}
